import { useCallback, useContext } from 'react';
import { ChatConversation } from '../../../../../../common';
import PaymentBalance from './paymentBalance';
import { ConversationContext } from '../../../../../../context/conversationContext';
import * as api from '../../../../../../api';
import PaymentSelection from './paymentSelectMethod';
import PaymentConfirmed from './paymentConfirmed';

interface Props {
  message: ChatConversation;
  showTextAnimation: boolean;
}

const ViewOrPayBill: React.FC<Props> = ({ message, showTextAnimation }) => {
  const conversationContext = useContext(ConversationContext);

  const onMakePaymentClicked = useCallback(() => {
    if (!conversationContext) return;
    conversationContext.updateCurrentMessage({
      ...message,
      intent: api.Assistant.Intent.Payment,
      intentComponent: api.Assistant.IntentComponent.PaymentSelectMethod,
    });
  }, [message, conversationContext]);

  if (!('intentComponent' in message) || !message.intentComponent) {
    return (
      <PaymentBalance
        message={message}
        showTextAnimation={showTextAnimation}
        onMakePaymentClicked={onMakePaymentClicked}
      />
    );
  }

  switch (message.intentComponent) {
    case api.Assistant.IntentComponent.PaymentConfirmed:
      return (
        <PaymentConfirmed
          message={message}
          showTextAnimation={showTextAnimation}
        />
      );
    case api.Assistant.IntentComponent.PaymentSelectMethod:
      return (
        <PaymentSelection
          message={message}
          showTextAnimation={showTextAnimation}
        />
      );
  }
};

export default ViewOrPayBill;
